// eslint-disable-next-line func-names
(function (Drupal, $) {
  const movingZoomCursor = (el) => {
    const $cursor = $(el);

    if ($cursor.length > 0) {
      $cursor.on('mousemove', (e) => {
        $cursor.css({
          backgroundPositionX: `${e.offsetX}px`,
          backgroundPositionY: `${e.offsetY}px`,
        });
      });
    }
  };

  Drupal.behaviors.mstZoomInMedia = {
    attach(context) {
      $('.zoom-in-cursor', context).each((index, element) => movingZoomCursor(element));
    },
  };
}(Drupal, jQuery));
